/* eslint-disable max-len */
import { useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useLazyGetConfigsQuery, useUpdateConfigMutation } from '@modules/config';
import { MESSAGES } from '@app/constant';
import { ConfigFormSchema } from '@modules/config/types';

import { IFlowProcess } from './helper/types';
import {
  hours,
  days,
  initialFlowState,
  createConfigSchema,
  defaultValues,
} from './helper/data';

export const useConfigLogic = () => {
  const [updateConfig] = useUpdateConfigMutation()
  const [getConfig] = useLazyGetConfigsQuery()
  const [flowProcess, setFlowProcess] = useState<IFlowProcess>(initialFlowState)

  const methods = useForm<ConfigFormSchema>({
    resolver: yupResolver(createConfigSchema),
    mode: 'all',
    defaultValues
  });

  const {
    reset,
    watch,
    register,
    handleSubmit,
  } = methods;

  const workingHours = watch('workingHours')

  const handleLoadingState = (isLoading: boolean, successMessage: string = '') => {
    setFlowProcess((prev) => ({
      ...prev,
      isButtonLoading: isLoading,
      isSuccess: successMessage,
      largeImageMessage: '',
    }));
  };

  const onSubmit = async (data: ConfigFormSchema) => {
    try {
      handleLoadingState(true);

      await updateConfig({ body: data }).unwrap()
      handleLoadingState(false, MESSAGES.mapConfigHasBeenSuccessfullyCreated);
    } catch (error: any) {
      handleLoadingState(false, error?.data?.message || MESSAGES.somethingWentWrong);
    }
  };

  const getConfigData = async () => {
    try {
      const { data } = await getConfig().unwrap()

      reset(structuredClone(data));
    } catch (error) {
      console.log("Error", error);
    } finally {
      setFlowProcess((prev) => ({ ...prev, isLoading: false }))
    }
  }

  useEffect(() => {
    getConfigData()
  }, [])

  return {
    ...flowProcess,
    hours,
    days,
    methods,
    workingHours,
    watch,
    register,
    onSubmit,
    handleSubmit,
  }
}
